module.exports = __webpack_public_path__ + "static/media/logo-mondino-negative.eb4fb420.jpg";